import create from 'zustand';

// define the store

export const useStore = create((set) => ({
  values: {},
  isApprovalFABVisible: true,
  replyCount: {},
  approvalDocs: { id: null, docs: null },
  maximizedApprovalReport: false,
  openInviteesModal: false,
  deletedAction: [],
  addedAction: [],

  setValues: (values) => set(() => ({ values: { ...values } })),
  setOpenInviteesModal: () => set(() => ({ openInviteesModal: true })),
  setCloseInviteesModal: () => set(() => ({ openInviteesModal: false })),
  addActionItemFn: (val) => set((state) => ({ addedAction: [...state.addedAction, val] })),
  deleteActionItemFn: (val) => set((state) => ({ deletedAction: [...state.deletedAction, val] })),

  reset: () => { set(() => ({ values: {} })) },
  setReplyCount: (val) => {
    set((state) => ({ replyCount: { ...state.replyCount, ...val } }))
  },
  setMaximizedApprovalReport: (val) => set(() => ({ maximizedApprovalReport: val })),

  setApprovalDocs: (val) => {
    set((state) => ({ approvalDocs: { id: val.id, doc: Array.isArray(val.docs) ? val.docs : [...val.docs] } }))
  },
  incrementReplyCount: (id) => set((state) => {
    if (state.replyCount[id]) {
      const reply = state.replyCount
      if (reply[id]) {
        reply[id]['count'] = reply[id]['count'] + 1
        return {
          replyCount: {
            ...reply
          }
        }
      } else
        return {
          replyCount: {
            ...state.replyCount
          }
        }
    }
  }),
  removeApprovalFab: () => set(() => ({ isApprovalFABVisible: false })),
  showApprovalFab: () => set(() => ({ isApprovalFABVisible: true })),
}));